import styled from "@emotion/styled";
import { RadioFormControlLabel } from "@kaltura/ds-react-components";
import { formControlLabelClasses } from "@mui/material";
import { KmsTypeFilterItemRadio } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { ChangeEvent } from "react";
import { FilterItemAdditionalProps } from "./FilterItemAdditionalProps";

export type RadioFilterItemProps = KmsTypeFilterItemRadio & FilterItemAdditionalProps;

const StyledRadioFilterItem = styled("div")(({ theme }) => ({
    marginTop: 0,
    marginBottom: theme.spacing(2),
    [`& .${formControlLabelClasses.label} p`]: { fontSize: 14 },
}));

/**
 * radio filter item - a single (controlled)radio in a filter
 */
export function RadioFilterItem(props: RadioFilterItemProps) {
    const sendButtonAnalytics = useButtonAnalytics();
    const { label, param, value, checked = false, onChange, disabled = false } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const eventName = `Filters - ${param} - ${value}`;
        sendButtonAnalytics(eventName, ButtonClickAnalyticsType.FILTER);
        onChange(param, value, event.target.checked, false);
    };

    return (
        <StyledRadioFilterItem className="kms-ds-filter-radio-item">
            <RadioFormControlLabel
                label={label}
                value={value}
                disabled={disabled}
                checked={checked}
                onChange={handleChange}
            />
        </StyledRadioFilterItem>
    );
}

export default RadioFilterItem;
